function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip-path"
}, /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_383",
  "data-name": "Rectangle 383",
  width: 225,
  height: 106,
  transform: "translate(0 123.794)",
  fill: "#009639",
  opacity: 0.819
})));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "Mask_Group_1",
  "data-name": "Mask Group 1",
  transform: "translate(0 -123.794)",
  opacity: 0.697,
  clipPath: "url(#clip-path)"
}, /*#__PURE__*/React.createElement("g", {
  id: "loading-energy-saving",
  transform: "translate(51.407 123.917)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_412",
  "data-name": "Group 412",
  transform: "translate(0 48.463)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_411",
  "data-name": "Group 411"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_285",
  "data-name": "Path 285",
  d: "M110.71,357.205l-.015,0h0a2.238,2.238,0,0,0-2.7,1.638,48.452,48.452,0,0,1-92.228,6.4l8.015-1.688a2.238,2.238,0,0,0,1.25-3.688l-7.19-8.027-7.127-7.877a2.238,2.238,0,0,0-3.9.688L3.463,354.889l-3.351,10.2A2.238,2.238,0,0,0,2.7,367.98l8.628-1.813a52.928,52.928,0,0,0,101.018-6.252A2.238,2.238,0,0,0,110.71,357.205Z",
  transform: "translate(0.001 -343.093)",
  fill: "#009639"
}))), /*#__PURE__*/React.createElement("g", {
  id: "Group_415",
  "data-name": "Group 415",
  transform: "translate(42.935 20.022)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_414",
  "data-name": "Group 414"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_413",
  "data-name": "Group 413"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_286",
  "data-name": "Path 286",
  d: "M296.619,170.1H272.724a.425.425,0,0,0-.4.288l-11.141,34.085a.425.425,0,0,0,.248.548.421.421,0,0,0,.14.027h10.153l-7.815,30.384a.425.425,0,0,0,.713.425l30.959-35.961a.425.425,0,0,0-.313-.7H282.077l14.9-28.484a.414.414,0,0,0,.063-.188A.425.425,0,0,0,296.619,170.1Z",
  transform: "translate(-261.156 -170.095)",
  fill: "#009639"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_287",
  "data-name": "Path 287",
  d: "M479.449,172.681Z",
  transform: "translate(-443.561 -172.256)",
  fill: "#009639"
})))), /*#__PURE__*/React.createElement("g", {
  id: "Group_417",
  "data-name": "Group 417",
  transform: "translate(9.371 0)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_416",
  "data-name": "Group 416"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_288",
  "data-name": "Path 288",
  d: "M167.85,80.939a2.237,2.237,0,0,0-1.16-.063v-.038l-8.628,1.813A52.928,52.928,0,0,0,57.044,88.9,2.238,2.238,0,0,0,61.4,89.941a48.452,48.452,0,0,1,92.228-6.4l-8.015,1.688a2.238,2.238,0,0,0-1.25,3.688l7.19,8.027,7.09,7.915a2.238,2.238,0,0,0,3.9-.688l3.351-10.241,3.389-10.166A2.238,2.238,0,0,0,167.85,80.939Z",
  transform: "translate(-57 -48.313)",
  fill: "#009639"
})))));

function SvgLoader(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 225,
    height: 106,
    viewBox: "0 0 225 106",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoader);
export default __webpack_public_path__ + "static/media/Loader.ccb2222f.svg";
export { ForwardRef as ReactComponent };